import React, { useState, memo } from 'react';
import { withTranslation } from 'react-i18next';
import {
    DaButton,
    Dropdown,
    DropdownControl,
    Popin,
    PlusIcon,
    ModalProvider,
    ModalControl,
    Box,
} from '@paygreen/paygreen-ui';
import { addProductModes } from '../../utils/constants';
import AddProductPopin from './AddProductPopin';
import AddManuallyProduct from './addManuallyProduct/AddManuallyProduct';
import AddCsvProduct from './addCsvProduct/AddCsvProduct';
import AddCmsProduct from './AddCmsProduct';

const SwitchAddProductMode = ({
    isOpen,
    setOpen,
    addProductMode,
    setIsLoading,
    isLoading,
    handleRefreshData,
}) => {
    const modalProps = {
        setIsLoading,
        isLoading,
        handleRefreshData,
        isOpen,
        setOpen,
    };

    switch (addProductMode) {
        case addProductModes.cms:
            return <AddCmsProduct {...modalProps} />;
        case addProductModes.csv:
            return <AddCsvProduct {...modalProps} />;
        default:
            return <AddManuallyProduct {...modalProps} />;
    }
};

const ProductsButtons = memo(
    ({ t, isLoading, setIsLoading, handleRefreshData }) => {
        // to choose between the 3 ways for adding a product
        const [addProductMode, setAddProductMode] = useState();

        return (
            <ModalProvider>
                <Dropdown>
                    <Box>
                        <button type="button">
                            <DaButton
                                buttonSize="md"
                                gradient="theme"
                                icon={<PlusIcon />}
                            >
                                {t('matching.addButton')}
                            </DaButton>
                        </button>
                    </Box>

                    <Popin shadowSize="md" align="left" blockWidth="md">
                        <DropdownControl>
                            <AddProductPopin
                                setAddProductMode={setAddProductMode}
                            />
                        </DropdownControl>
                    </Popin>
                </Dropdown>

                <ModalControl>
                    <SwitchAddProductMode
                        addProductMode={addProductMode}
                        setIsLoading={setIsLoading}
                        isLoading={isLoading}
                        handleRefreshData={handleRefreshData}
                    />
                </ModalControl>
            </ModalProvider>
        );
    },
);

export default withTranslation('common')(ProductsButtons);
